import { Drawer, Text } from "@mantine/core";

import type { AssociatedObject } from "./types";
import MeetingDetailsPanel from "./MeetingDetailsPanel";

type MeetingDetailsDrawerProps = {
  opened: boolean;
  onClose: () => void;
  meeting: AssociatedObject | null;
  position?: "left" | "right";
};

const MeetingDetailsDrawer = ({ opened, onClose, meeting, position = "right" }: MeetingDetailsDrawerProps) => (
  <Drawer
    opened={opened}
    onClose={onClose}
    position={position}
    size="760px"
    title={<Text fw={700} c="text.9">Meeting</Text>}
    overlayProps={{ blur: 4, opacity: 0.25 }}
    classNames={{
      header: "border-b border-gray-100",
      body: "p-4",
    }}
  >
    <MeetingDetailsPanel meeting={meeting} />
  </Drawer>
);

export default MeetingDetailsDrawer;
